<template>
  <div>
    <!-- 搜索框 -->
    <a-card title="告警人员管理列表">
        
      <a-form layout="inline" @submit="handleSubmit" :form="form">
          <a-form-item label="系统编码">
              <a-input  v-model="searchP.syscode"  placeholder="系统编码/名称" ></a-input>
          </a-form-item>
          <a-form-item label="用户名">
              <a-input  v-model="searchP.username"  placeholder="用户名/手机号" ></a-input>
          </a-form-item>
          <a-form-item>
                <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
          </a-form-item>

          <a-form-item>
                <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                </a-button>
          </a-form-item>
         <router-link :to="{path:'useradd'}"  class="f-right">
                <a-button type="primary" class="fr opbuttonmt">新增</a-button>
         </router-link>

      </a-form>
    </a-card>

    <!-- 告警列表 -->
    <a-table :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="id" >
    
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
           <span> 
                <router-link  :to="{ path:'useredit', query: { id: record.id}}"
                >编辑
                </router-link>
          </span>
           <a-popconfirm title="确认删除?" @confirm="() => onDelete(record)">
                    <a  href="javascript:;">删除</a>
           </a-popconfirm>
        </div>
      </template>

    </a-table>

   <a-pagination class="my_pagenation" v-model="pagination.current" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />
     
  </div>
</template>
<script>
import { mapState } from "vuex";
const data = [];

let pagination={
    total:0,
    pageSize:0,
    current:1,
}
const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },{
        title: "系统编码",
        dataIndex: "syscode",
        width:120
    },
    {
        title: "通知责任人",
        dataIndex: "username",
        width:150
    },
    {
        title: "手机号",
        dataIndex: "telephone",
        width:120
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'operation' },
    }

];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            pagination,
            tLoading:true,
            currentItemList:'',
            datasource:{
                isShow:false,
                authedStr:''
            },
        };
    },
    methods: {

        handlePageChange(c_p){
            this.getAlarmUserList(c_p)
        },
        getAlarmUserList(cpage){
            let c_params = {
                ...this.searchP
            }
           
            c_params.page =cpage ? cpage : 1;
            c_params.pageSize = this.pagination.pageSize;
            c_params.urlparams = false;
            this.tLoading = true;
            this.$store.dispatch({
                type: "alarmmanager/userlist",
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                if(result){
                    this.data = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.current = parseInt(result.page);
                }
            })
        },

        handleSearchReset(){
            this.$store.dispatch({
                type: "alarmmanager/getEmptySearch",
                showMsg: true
            })
        },

        handleSubmit(e){
            e.preventDefault();
            this.getAlarmUserList(1)
        },
        
        //删除
        onDelete(record) {
            this.$store.dispatch({
                type: "alarmmanager/userdel",
                params: record
            }).then(() => {
                this.getAlarmUserList(1)
            });
        },

    },
    computed:{
        ...mapState('alarmmanager', {
            searchP: state => state.searchP,
        })
    },

    mounted(){
        const { query } = this.$route;
        this.getAlarmUserList(query);
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
